<script>
	export let dataMapped;
	import {default as Notebook} from '@manaakiwhenua/frag-svelte/src/Notebook.svelte';
    import {default as maoriFactsheet} from '../notebooks/@ridgenb/maori-factsheet';

	let cells = ['fullSmapName'];

	$: overrides = new Map([['dataMapped', dataMapped]]);
</script>

<Notebook notebook={maoriFactsheet} cells={cells} overrides={overrides}/>